import { render, staticRenderFns } from "./MixtureTile.vue?vue&type=template&id=8748f970&scoped=true&"
import script from "./MixtureTile.vue?vue&type=script&lang=js&"
export * from "./MixtureTile.vue?vue&type=script&lang=js&"
import style0 from "./MixtureTile.vue?vue&type=style&index=0&id=8748f970&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8748f970",
  null
  
)

export default component.exports